import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Laptop, Wifi, Heart, GraduationCap } from "lucide-react";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

const ConditionsSection = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useIntersectionObserver();
  const { elementRef: listRef, isVisible: listVisible } = useIntersectionObserver();
  const { elementRef: formationRef, isVisible: formationVisible } = useIntersectionObserver();

  const conditions = [
    { text: "Aucune expérience exigée en recrutement ou en commerce", icon: CheckCircle },
    { text: "Tous statuts juridiques acceptés", icon: CheckCircle },
    { text: "Aucune exclusivité imposée", icon: CheckCircle },
    { text: "Pas de minimum d'activité ni d'objectif imposé", icon: CheckCircle },
    { text: "Un ordinateur, une bonne connexion Internet et de la motivation suffisent !", icon: Laptop }
  ];

  return (
    <section className="py-20 gradient-bg-light">
      <div className="container mx-auto px-6">
        <div 
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-800 ${
            titleVisible ? 'animate-slide-in-up' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Quelles sont les conditions pour <span className="gradient-text">rejoindre le réseau</span> ?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div 
            ref={listRef}
            className="grid gap-6 mb-12"
          >
            {conditions.map((condition, index) => (
              <Card 
                key={index} 
                className={`group hover:shadow-lg transition-all duration-300 border-l-4 border-l-primary bg-white/80 backdrop-blur-sm ${
                  listVisible 
                    ? `animate-slide-in-left animate-stagger-${index + 1}` 
                    : 'opacity-0 -translate-x-10'
                }`}
              >
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
                      <condition.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <p className="text-lg text-gray-700 leading-relaxed">{condition.text}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card 
            ref={formationRef}
            className={`bg-white shadow-xl border-2 border-primary/20 transition-all duration-800 ${
              formationVisible ? 'animate-scale-in' : 'opacity-0 scale-95'
            }`}
          >
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 mx-auto rounded-full gradient-bg flex items-center justify-center mb-6">
                <GraduationCap className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Formation initiale incluse</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Une <strong>formation initiale immersive d'une semaine</strong> à Agen est incluse dans le parcours.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ConditionsSection;
